import Header from "../../../components/header";
import Footer from "../../../components/footer";
import TeachersListingBanner from '../../components/01_banner/01_banner';

import stype from "./02_teachersdetails.css"

import { useEffect, useMemo, useState } from "react";
import { useRoute } from "wouter";
import axios from 'axios';
import PricingStudents from "../../components/02_pricingstudents/02_pricingstudents";

export default function TeacherDetails() {    
    const [, params] = useRoute("/teachers/:UID");
    const UID = params?.UID;

    const [people, setPeople] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadData() {
            try {
                const response = await fetch(
                    "https://sursaathi.in/teacherslisting/teacherslisting.json"
                );

                const data = await response.json();

                setPeople(data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        loadData();
    }, []);

    const teacher = useMemo(() => {
        return people.find((person) =>
            String(person.UID).trim().toLowerCase() ===
            String(UID).trim().toLowerCase()
        );
    }, [people, UID]);

    const relatedTeachers = useMemo(() => {
        if (!teacher) return [];

        return people
            .filter(person => {
                // Exclude current teacher
                if (person.UID === teacher.UID) return false;

                // Match instrument (case insensitive)
                return (
                    String(person.Instrument).trim().toLowerCase() ===
                    String(teacher.Instrument).trim().toLowerCase()
                );
            })
            .slice(0, 3);
    }, [people, teacher]);

    const [fname, setFname] = useState('');
    const [femail, setFemail] = useState('');
    const [fphone, setFphone] = useState('');
  
    const handleSubmit = async (e) => {
        e.preventDefault();
      
        const formData = new FormData();
        formData.append("name", fname);
        formData.append("email", femail);
        formData.append("phone", fphone);
        formData.append("uid", teacher.UID);
        formData.append("teachername", teacher.Name);
        formData.append("teachercontact", teacher.Number);
        formData.append("teacheremail", teacher.Email);

        try {
          const res = await axios.post("https://sursaathi.in/getteacherinfo.php", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          alert("Success: " + res.data.message);
        } catch (err) {
          alert("Failed: " + (err.response?.data?.error || "Unknown error"));
        }
      };  


    if (loading) {
        return (
            <div>
                <Header />
                <div style={{ padding: 40 }}>
                    Loading...
                </div>
                <Footer />
            </div>
        );
    }

    if (!teacher) {
        return (
            <div>
                <Header />
                <div style={{ padding: 40 }}>
                    <h2>Teacher not found.</h2>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div style={{ background: "#FFFDF4", minHeight: "100vh" }}>
            <Header />
                <div className="TeacherDetailsPage-Main">
                    <div className="TeacherDetailsPage-Main-Intro-Section-Info">
                        <img src={teacher.PhotoURL} alt="" />
                        <div className="TeacherDetailsPage-Main-Intro-Section-Info-Details">
                            <h1>{teacher.Name}</h1>
                            <span>{teacher.Headline}</span>
                            <a href="#contact">GET CONTACT DETAILS</a>
                        </div>
                    </div>
                    <div className="TeacherDetailsPage-Main-Qualifications">
                        <div className="TeacherDetailsPage-Main-Qualifications-Split">
                            <div className="TeacherDetailsPage-Main-Qualifications-Section">
                                <h3>OVERVIEW</h3>
                                <p>
                                    {teacher.Description}
                                </p>
                            </div>
                            <div className="TeacherDetailsPage-Main-Qualifications-Section">
                                <h3>Services</h3>
                                {teacher.Services?.map((service, index) => (
                                    <p
                                        key={index}
                                        className="TeacherDetailsPage-Main-Qualifications-Section-Service"
                                    >
                                        {service}
                                    </p>
                                ))}
                            </div>
                            <div className="TeacherDetailsPage-Main-Qualifications-Section">
                                <h3>Education</h3>
                                <p>
                                    {teacher.Education}
                                </p>
                            </div>
                        </div>
                        <div className="TeacherDetailsPage-Main-Qualifications-Split">
                            <div className="TeacherDetailsPage-Main-Qualifications-Section">
                                <h3>Details</h3>
                                <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex">
                                    <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Details">
                                        <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Symbol"></div>
                                        <p>Instruments</p>
                                    </div>
                                    <p className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Content">{teacher.Instrument}</p>
                                </div>
                                <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex">
                                    <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Details">
                                        <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Symbol"></div>
                                        <p>Location</p>
                                    </div>
                                    <p className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Content">{teacher.Location}</p>
                                </div>
                                <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex">
                                    <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Details">
                                        <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Symbol"></div>
                                        <p>Teaching Mode</p>
                                    </div>
                                    <p className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Content">{teacher.TeachingMode}</p>
                                </div>
                                <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex">
                                    <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Details">
                                        <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Symbol"></div>
                                        <p>Language</p>
                                    </div>
                                    <p className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Content">{teacher.Language}</p>
                                </div>
                                <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex">
                                    <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Details">
                                        <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Symbol"></div>
                                        <p>Gender</p>
                                    </div>
                                    <p className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Content">{teacher.Gender}</p>
                                </div>
                                <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex">
                                    <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Details">
                                        <div className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Symbol"></div>
                                        <p>Fees</p>
                                    </div>
                                    <p className="TeacherDetailsPage-Main-Qualifications-Section-Flex-Content">{teacher.Fees}</p>
                                </div>
                            </div>
                            <form id="contact" className="TeacherDetailsPage-Form" onSubmit={handleSubmit}>
                                <h2>Get in touch</h2>
                                <label htmlFor="">Name</label>
                                <input type="text" name="" id="" value={fname} onChange={(e) => setFname(e.target.value)} required/>
                                <label htmlFor="">Number</label>
                                <input type="text" name="" id="" value={fphone} onChange={(e) => setFphone(e.target.value)} required/>
                                <label htmlFor="">Email</label>
                                <input type="text" name="" id="" value={femail} onChange={(e) => setFemail(e.target.value)} required/>
                                <button type="submit">Get Contact Details</button>
                            </form>
                        </div>
                    </div>
                </div>
                <PricingStudents />
                <div className="TeacherDetailsPage-SuggestionsSection">
                    <h2>More {teacher.Instrument} Teachers</h2>

                    <div className="TeacherDetailsPage-SuggestionsSection-Flex">
                        {relatedTeachers.length > 0 ? (
                            relatedTeachers.map(item => (
                                <a
                                    key={item.UID}
                                    href={`/teachers/${item.UID}`}
                                    className="TeacherDetailsPage-SuggestionsSection-Flex-Card"
                                >
                                    <img src={item.PhotoURL} alt={item.Name} />

                                    <h3>{item.Name}</h3>
                                    <div className="TeacherDetailsPage-SuggestionsSection-Flex-Card-Keys">
                                        <span>Instrument: {item.Instrument}</span>
                                        <span>Location: {item.Location}</span>
                                    </div>
                                    <p>{item.Description}</p>
                                </a>
                            ))
                        ) : (
                            <p>No similar teachers found.</p>
                        )}
                    </div>
                </div>
                <TeachersListingBanner />
            <Footer />
        </div>
    );
}